__turbopack_context__.v({
  "header": "Header-module__arFiJq__header",
  "header__button": "Header-module__arFiJq__header__button",
  "header__container": "Header-module__arFiJq__header__container",
  "header__container__right": "Header-module__arFiJq__header__container__right",
  "header__logo": "Header-module__arFiJq__header__logo",
  "header__logo__scrolled": "Header-module__arFiJq__header__logo__scrolled",
  "header__menu": "Header-module__arFiJq__header__menu",
  "header__menu__scrolled": "Header-module__arFiJq__header__menu__scrolled",
  "header__phone": "Header-module__arFiJq__header__phone",
  "header__phone__scrolled": "Header-module__arFiJq__header__phone__scrolled",
  "header__scrolled": "Header-module__arFiJq__header__scrolled",
  "phoneicon": "Header-module__arFiJq__phoneicon",
});
